import { Dispatch, SetStateAction } from 'react';
import { Enum } from 'interfaces';
import { API } from '../data/30pay.api';
import { get } from 'scripts';

export const _getOrderStates = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Enum[] | undefined>>
) => {
    setLoading(true)
    await get<Enum[]>(API.enum.orderStates).then((response) => {
        setLoading(false)
        setData(response.value.value)
    })
}

export const _getOrderSides = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Enum[] | undefined>>
) => {
    setLoading(true)
    await get<Enum[]>(API.enum.orderSides).then((response) => {
        setLoading(false)
        setData(response.value.value)
    })
}

export const _getTransactionStates = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Enum[] | undefined>>
) => {
    setLoading(true)
    await get<Enum[]>(API.enum.transactionStates).then((response) => {
        setLoading(false)
        setData(response.value.value)
    })
}

export const _getTransactionTypes = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Enum[] | undefined>>
) => {
    setLoading(true)
    await get<Enum[]>(API.enum.transactionTypes).then((response) => {
        setLoading(false)
        setData(response.value.value)
    })
}

export const _getMarketTypes = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Enum[] | undefined>>
) => {
    setLoading(true)
    await get<Enum[]>(API.enum.marketTypes).then((response) => {
        setLoading(false)
        setData(response.value.value)
    })
}

export const _getOrderTransactionStates = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Enum[] | undefined>>
) => {
    setLoading(true)
    await get<Enum[]>(API.enum.orderTransactionStates).then((response) => {
        setLoading(false)
        setData(response.value.value)
    })
}

export const _getOrderTransactionTypes = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Enum[] | undefined>>
) => {
    setLoading(true)
    await get<Enum[]>(API.enum.orderTransactionTypes).then((response) => {
        setLoading(false)
        setData(response.value.value)
    })
}

export const _getNotificationReasons = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Enum[] | undefined>>
) => {
    setLoading(true)
    await get<Enum[]>(API.enum.notificationReasons).then((response) => {
        setLoading(false)
        setData(response.value.value)
    })
}

export const _getTicketStates = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Enum[] | undefined>>
) => {
    setLoading(true)
    await get<Enum[]>(API.enum.ticketStates).then((response) => {
        setLoading(false)
        setData(response.value.value)
    })
}